import { Children, Component, createElement } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};

var isEmptyChildren = function (children) {
    return Children.count(children) === 0;
};

var Squeezy = (function (_super) {
    __extends(Squeezy, _super);
    function Squeezy(props) {
        var _this = _super.call(this, props) || this;
        _this.reducer = function (state, action) {
            if (_this.props.debug) {
                console.log("Squeezy " + _this.props.id + ": " + action.toUpperCase());
            }
            switch (action) {
                case 'toggle':
                    return { isOpen: !state.isOpen };
                case 'open':
                    return { isOpen: true };
                case 'close':
                    return { isOpen: false };
                default:
                    return state;
            }
        };
        _this.dispatch = function (action) {
            if (_this.props.isOpen === undefined) {
                _this.setState(function (prevState) { return _this.reducer(prevState, action); }, function () {
                    _this.props.onToggle(_this.state, _this.getSqueezyHelpers());
                });
            }
            else {
                _this.props.onToggle({ isOpen: !_this.props.isOpen }, _this.getSqueezyHelpers());
            }
        };
        _this.getButtonProps = function (props) {
            return __assign({ type: 'button', 'aria-expanded': _this.state.isOpen, 'aria-controls': _this.props.id, id: "accordian-control-" + _this.props.id, onClick: _this.toggle }, props);
        };
        _this.getContentProps = function (props) {
            return __assign({ id: _this.props.id, 'aria-hidden': !_this.state.isOpen }, props);
        };
        _this.toggle = function () { return _this.dispatch('toggle'); };
        _this.open = function () { return _this.dispatch('open'); };
        _this.close = function () { return _this.dispatch('close'); };
        _this.getSqueezyProps = function () {
            return __assign({}, _this.state, _this.getSqueezyHelpers());
        };
        _this.getSqueezyHelpers = function () {
            return {
                getButtonProps: _this.getButtonProps,
                getContentProps: _this.getContentProps,
                toggle: _this.toggle,
                open: _this.open,
                close: _this.close,
            };
        };
        _this.state = {
            isOpen: props.isOpen || props.defaultOpen,
        };
        return _this;
    }
    Squeezy.prototype.render = function () {
        var _a = this.props, render = _a.render, component = _a.component, children = _a.children;
        return component
            ? createElement(component, this.getSqueezyProps())
            : render
                ? render(this.getSqueezyProps())
                : children
                    ? typeof children === 'function'
                        ? children(this.getSqueezyProps())
                        : !isEmptyChildren(children) ? Children.only(children) : null
                    : null;
    };
    Squeezy.defaultProps = {
        defaultOpen: false,
        onToggle: function () { },
    };
    return Squeezy;
}(Component));

export { Squeezy };
//# sourceMappingURL=index.es6.js.map
